import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const toastService = {
  success: (message, options = {}) => {
    toast.success(message, { position: "top-right", ...options });
  },
  error: (message, options = {}) => {
    toast.error(message, { position: "top-right", ...options });
  },
  info: (message, options = {}) => {
    toast.info(message, { position: "top-right", ...options });
  },
  warning: (message, options = {}) => {
    toast.warn(message, { position: "top-right", ...options });
  },
};

export default toastService;